class CustomSlideshow {
  constructor(container) {
    this.container = container;
    this.slidesWrapper = container.querySelector('.cs-slideshow__wrapper');
    this.slides = container.querySelectorAll('.cs-slide');
    this.prevBtn = container.querySelector('.cs-button--prev');
    this.nextBtn = container.querySelector('.cs-button--next');
    this.dotsContainer = container.querySelector('.cs-dots');
    this.currentIndex = 0;
    this.totalSlides = this.slides.length;
    this.autoplay = container.dataset.autoplay === 'true';
    this.speed = parseInt(container.dataset.speed) || 7000;
    this.autoplayInterval = null;

    this.init();
  }

  init() {
    if (this.totalSlides <= 1) return;
    this.createDots();
    this.updateDots();
    this.updateSlideVisibility();
    this.bindEvents();
    if (this.autoplay) {
      this.startAutoplay();
    }
  }

  createDots() {
    if (!this.dotsContainer) return;
    for (let i = 0; i < this.totalSlides; i++) {
      const dot = document.createElement('div');
      dot.classList.add('cs-dot');
      dot.dataset.index = i;
      dot.addEventListener('click', () => this.goToSlide(i));
      this.dotsContainer.appendChild(dot);
    }
  }

  updateDots() {
    if (!this.dotsContainer) return;
    const dots = this.dotsContainer.querySelectorAll('.cs-dot');
    dots.forEach((dot, idx) => {
      if (idx === this.currentIndex) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }

  updateSlideVisibility() {
    const offset = -this.currentIndex * 100;
    this.slidesWrapper.style.transform = `translateX(${offset}%)`;
  }

  goToSlide(index) {
    if (index === this.currentIndex) return;
    this.currentIndex = (index + this.totalSlides) % this.totalSlides;
    this.updateSlideVisibility();
    this.updateDots();
    if (this.autoplay) {
      this.resetAutoplay();
    }
  }

  nextSlide() {
    this.goToSlide(this.currentIndex + 1);
  }

  prevSlide() {
    this.goToSlide(this.currentIndex - 1);
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.prevSlide());
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.nextSlide());
    }
  }

  startAutoplay() {
    this.autoplayInterval = setInterval(() => this.nextSlide(), this.speed);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
  }

  resetAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const slideshows = document.querySelectorAll('.cs-slideshow');
  slideshows.forEach(slideshow => new CustomSlideshow(slideshow));
});